/**
 * functions to provide the bounds used by the map
 */

// eslint-disable-next-line import/no-unresolved
import { computed, ref, watch } from '@vue/composition-api';

export default ({ store }) => {
  const mapBounds = ref(null);
  const boundsSource = ref(null);
  const waitForLocData = computed(() => store.state.locationRequestInprogress);
  const bbox = computed(() => store.getters.getSearchLocationFilter('BBoxString'));
  const storeLocationBounds = computed(() => store.getters.getLocationBounds);
  const aggBounds = computed(() => store.getters.getAggregation('searchBounds'));

  const setBoundsSource = (source) => {
    boundsSource.value = source;
  };

  const bBoxBounds = computed(() => {
    const bounds = [];
    if (bbox.value) {
      const [neLon, neLat, swLon, swLat] = bbox.value.split(',');
      setBoundsSource('BBoxString');
      bounds.push({ lat: neLat, lng: neLon });
      bounds.push({ lat: swLat, lng: swLon });
    }
    return bounds;
  });
  const locationBounds = computed(() => {
    const bounds = [];

    if (storeLocationBounds.value.minLat) {
      bounds.push({ lat: storeLocationBounds.value.minLat, lng: storeLocationBounds.value.minLong });
      bounds.push({ lat: storeLocationBounds.value.maxLat, lng: storeLocationBounds.value.maxLong });
      setBoundsSource('locationBounds');
    }
    return bounds;
  });
  const aggregationBounds = computed(() => {
    const bounds = [];
    if (Object.keys(aggBounds.value).length && aggBounds.value.top_left && aggBounds.value.bottom_right) {
      bounds.push({ lat: aggBounds.value.top_left.lat, lng: aggBounds.value.top_left.lon });
      bounds.push({ lat: aggBounds.value.bottom_right.lat, lng: aggBounds.value.bottom_right.lon });
      setBoundsSource('searchBoundsAggregation');
      bounds.push({ lat: aggBounds.value.bottom_right.lat, lng: aggBounds.value.bottom_right.lon });
    }

    return bounds;
  });

  const requestBounds = computed(() => {
    const bounds = [];
    if (bBoxBounds.value.length) { return bBoxBounds.value; }
    if (locationBounds.value.length) { return locationBounds.value; }
    if (aggregationBounds.value.length && !waitForLocData.value) {
      return aggregationBounds.value;
    }
    return bounds;
  });

  watch(requestBounds, (bounds) => {
    if (bounds.length) { // prevent empty bounds
      mapBounds.value = bounds;
    }
  }, {
    immediate: true,
  });

  return { mapBounds, boundsSource };
};
